export const DYNAMIC_FORM_REQUIREMENT_MODES = [
	"require",
	"no require",
	"optional",
] as const;

export type DynamicFormRequirementMode =
	(typeof DYNAMIC_FORM_REQUIREMENT_MODES)[number];

export const DYNAMIC_FORM_ENTITY_KINDS = [
	"job",
	"ticket",
	"asset",
	"record",
] as const;

export type DynamicFormEntityKind = (typeof DYNAMIC_FORM_ENTITY_KINDS)[number];

export function enforcesRequiredFields(
	mode: DynamicFormRequirementMode,
): boolean {
	return mode === "require";
}

export function showsRequiredIndicator(
	mode: DynamicFormRequirementMode,
	required: boolean,
): boolean {
	if (mode === "no require") return false;
	return required;
}

/** True when any field on the form is marked required. */
export function hasRequiredDynamicFormField(
	fieldDefinitions: readonly { required?: boolean | null }[] | null | undefined,
): boolean {
	return (fieldDefinitions ?? []).some((field) => field.required === true);
}

export function requirementNoticeKey(
	mode: DynamicFormRequirementMode,
	entityKind: DynamicFormEntityKind | undefined,
): string | null {
	if (!entityKind || mode === "require") return null;
	const noun = entityKind.charAt(0).toUpperCase() + entityKind.slice(1);
	const when = mode === "no require" ? "create" : "edit";
	return `main.dynamicForm.requirementNotice.${when}${noun}`;
}
